module.exports = __webpack_public_path__ + "static/media/school_slide_mobile_2.a91b74c4.png";